<div id="timeLeftMessage{{id}}" class="item-image-mask-bottom" style="max-width:{{maxWidth}}px;">
    <p class="{{overtimeClass}}">{{{timeLeftBiddingMessage}}}
        <span id="timeLeft_{{id}}">{{{timeLeft}}}</span>
    </p>
</div>
